<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>维修/保养管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.phone" placeholder="联系人"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.project" placeholder="项目名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="refresh()">重置</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="formInline">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加维修/保养
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;" ref="taskTable">
      <el-table-column align="center" type="selection" width="60"></el-table-column>
      <el-table-column prop="phone" label="联系方式" show-overflow-tooltip></el-table-column>
      <el-table-column prop="project" label="项目名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="director" label="项目承接人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="description" label="问题描述" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" label="是否已处理">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">已处理</span>
          <span v-else>未处理</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="addtime1" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">详情</el-button>
          <!--<el-button size="mini" type="danger" @click="deleteRepair(scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="70%" @click="closeDialog">
      <div>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="联系方式" prop="phone" :required="true">
            <el-input size="small" v-model="editForm.phone" auto-complete="off" style="width: 20vw;"
                      placeholder="联系方式"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="project" :required="true">
            <el-input size="small" v-model="editForm.project" auto-complete="off" style="width: 20vw;"
                      placeholder="项目名称"></el-input>
          </el-form-item>
          <el-form-item label="项目承接人" prop="director" :required="true">
            <el-input size="small" v-model="editForm.director" auto-complete="off" style="width: 20vw;"
                      placeholder="项目承接人"></el-input>
          </el-form-item>
          <el-form-item label="问题描述" prop="description" :required="true">
            <el-input size="small" v-model="editForm.description" auto-complete="off" style="width: 20vw;"
                      placeholder="问题描述"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import {repairs, saveRepair} from "../../api/userMG";

  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        showEdit: false,
        title: '添加维修/保养',
        dates: '',
        formInline: {
          page: 1,
          limit: 10,
          pageSize: 10,
          task_object: '',
          task_type: '',
          task_group: ''
        },
        editForm: {
          id: 0,
          phone: '',
          project: '',
          director: '',
          description: '',
          image_url: '',
          status: '',
          addtime1: '',
        },
        rules: {
          phone: [
            {required: true, message: '请输入联系方式', trigger: 'blur'}
          ],
          project: [
            {required: true, message: '请输入项目名称', trigger: 'blur'}
          ],
          director: [
            {required: true, message: '请输入项目承接人', trigger: 'blur'}
          ],
          description: [
            {required: true, message: '请输入问题描述', trigger: 'blur'}
          ],
        },
        listData: [], //用户数据
        start: 1,
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      getdata(parameter) {
        let t = this
        this.loading = true
        repairs(parameter).then(res => {
          if (res.code == 200) {
            this.listData = res.item
            this.loading = false

            this.pageparm.currentPage = t.formInline.page
            this.pageparm.pageSize = t.formInline.limit
            this.pageparm.total = res.pageInfo.total
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function (row) {
        this.editFormVisible = true
        if (row != undefined) {
          this.title = '查看保养/维修'
          this.editForm = row
        } else {
          this.title = '添加维修/保养'
          this.editForm = {
            id: 0,
            phone: '',
            project: '',
            director: '',
            description: '',
            image_url: '',
            status: '',
            addtime1: '',
          }
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            let row = this.editForm
            let params = {
              phone: row.phone,
              project: row.project,
              director: row.director,
              description: row.description,
              type: 'jsws'
            }
            saveRepair(params)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                  this.getdata()
                  this.$refs['editForm'].resetFields()
                } else {
                  this.$message({
                    type: 'info',
                    message: '保存失败！'
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('维修/保养保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 删除保养/维修
      deleteRepair(row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteRepairs({id: row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '维修/保养已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: '任务删除失败!'
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('维修/保养删除失败，请稍后再试！')
            })
        })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false
        this.$refs[formName].resetFields()
      },
      refresh() {
        this.formInline.task_group = ''
        this.formInline.task_object = ''
        this.formInline.task_type = ''
        this.getdata(this.formInline)
      },
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .el-dialog {
    margin-top: -20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/repair/index.vue